export default "__VITE_ASSET__BPHO6YyG__"